"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRobotsTxt = buildRobotsTxt;
function buildRobotsTxt({ allow, pageSlugs }) {
    if (!allow) {
        return "User-agent: *\nDisallow: /\n";
    }
    const lines = ["User-agent: *", "Allow: /api/images/", "Disallow: /api/"];
    const slugRules = new Set();
    for (const slugs of Object.values(pageSlugs)) {
        slugRules.add(`Disallow: /*/${slugs.review}`);
        slugRules.add(`Disallow: /*/${slugs.result}`);
        slugRules.add(`Allow: /*/${slugs.result}/`);
    }
    return `${[...lines, ...slugRules].join("\n")}\n`;
}
